import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const AboutPage = () => {
  const values = [
    {
      title: 'An Outstanding Reputation',
      description:
        'Our firm has provided bonding and insurance services to the construction industry since 1957. Throughout our history we have maintained the highest degree of professionalism and service to our clients across Bucks County, Montgomery County, and all of Pennsylvania. Over the years our agency has grown with our clients and now enjoys one of the most recognized names in construction bonding and insurance services.',
      icon: 'ri-award-line',
    },
    {
      title: 'Valued Customers',
      description:
        'Our clients are mostly closely held, well managed, financially strong businesses who value relationships. We would appreciate the opportunity to establish a relationship with your firm. Our agency provides three service divisions which you can put to use in your firm. They are bonding services, insurance services, and risk management consulting services.',
      icon: 'ri-user-heart-line',
    },
    {
      title: 'The Alliance',
      description:
        'Effective June 1, 2017 The Stoll Agency, Inc. became the newest member of The Insurance Alliance. The Insurance Alliance is a collective of 10 premier independent agencies located in various regions of Pennsylvania. Through size, diversity and broad expertise, The Alliance offers on a regional level that which is normally found only with national brokers.',
      icon: 'ri-links-line',
    },
  ];

  return (
    <div className="min-h-screen bg-slate-900">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNiIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiLz48L2c+PC9zdmc+')]"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-green-500 text-sm font-semibold tracking-widest uppercase mb-4">Pennsylvania's Trusted Agency</p>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">About Us</h1>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Building trust and protecting contractors in Bucks County, Montgomery County, and Pennsylvania since 1957
          </p>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-16">
            {values.map((value, index) => (
              <div
                key={index}
                className={`flex flex-col ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                } gap-12 items-center`}
              >
                <div className="flex-1">
                  <div className="w-20 h-20 bg-green-500/10 border border-green-500/20 rounded-2xl flex items-center justify-center mb-6">
                    <i className={`${value.icon} text-4xl text-green-500`}></i>
                  </div>
                  <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                    {value.title}
                  </h2>
                  <p className="text-lg text-slate-300 leading-relaxed">{value.description}</p>
                  {value.title === 'The Alliance' && (
                    <a
                      href="https://www.theinsurancealliancenetwork.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center mt-6 text-green-500 hover:text-green-400 font-semibold"
                    >
                      Visit The Insurance Alliance
                      <i className="ri-arrow-right-line ml-2"></i>
                    </a>
                  )}
                </div>
                <div className="flex-1">
                  <div className="bg-slate-800 border border-slate-700 rounded-2xl p-12 h-80 flex items-center justify-center">
                    <i className={`${value.icon} text-9xl text-green-500/10`}></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* History Section */}
      <section className="py-20 bg-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <p className="text-green-500 text-sm font-semibold tracking-widest uppercase mb-3">Our Story</p>
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                Four Generations of Excellence
              </h2>
              <p className="text-lg text-slate-300 leading-relaxed mb-6">
                The Stoll Agency, Inc. is a 4th generation family business that has cultivated
                close relationships with our customers throughout <strong className="text-white">Bucks County</strong> and <strong className="text-white">Montgomery County</strong>. We have protected some of our clients for
                over 50 years.
              </p>
              <p className="text-lg text-slate-300 leading-relaxed mb-8">
                Our responsiveness is unmatched, and our turnaround time is fast. We understand the
                construction industry inside and out, and we're committed to providing the best
                service possible to Pennsylvania contractors.
              </p>
              <Link
                to="/contact"
                className="inline-block px-8 py-4 bg-green-600 text-white rounded-full font-semibold hover:bg-green-500 transition-all shadow-lg whitespace-nowrap"
              >
                Contact Us Today
              </Link>
            </div>
            <div className="grid grid-cols-2 gap-6">
              {[
                { value: '1957', label: 'Established' },
                { value: '4th', label: 'Generation' },
                { value: '100+', label: 'Markets' },
                { value: '50+', label: 'Years Service' },
              ].map((stat, i) => (
                <div key={i} className="bg-slate-900 border border-slate-700 rounded-2xl p-8 text-center">
                  <div className="text-4xl font-bold text-green-500 mb-2">{stat.value}</div>
                  <div className="text-slate-400 font-medium">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <p className="text-green-500 text-sm font-semibold tracking-widest uppercase mb-3">Meet the Team</p>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Our Leadership</h2>
            <div className="w-24 h-1 bg-green-600 mx-auto"></div>
          </div>

          <div className="flex flex-wrap justify-center gap-8">
            {/* Peter N. Stoll Jr. */}
            <div className="bg-slate-800 border border-slate-700 rounded-2xl overflow-hidden shadow-2xl w-full max-w-sm">
              <div className="h-80">
                <img
                  src="https://static.readdy.ai/image/878aa561146e1949d21d2a461d90b0e2/530099dc4f4ca8f801b8e4d8baca151e.png"
                  alt="Peter N. Stoll Jr., CPCU AFSB — President of The Stoll Agency"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-white mb-1">Peter N. Stoll, Jr., CPCU, AFSB</h3>
                <p className="text-green-500 font-semibold mb-4">President</p>
                <div className="space-y-2 text-slate-300 text-sm">
                  <p className="leading-relaxed"><strong className="text-white">35+ Years Experience</strong> Insuring and Bonding Contractors across Pennsylvania</p>
                  <p className="leading-relaxed">Pennsylvania State University B.S. in Insurance — William Elliot Insurance Scholarship recipient</p>
                  <p className="leading-relaxed"><strong className="text-white">CPCU</strong> — Chartered Property and Casualty Underwriter</p>
                  <p className="leading-relaxed"><strong className="text-white">AFSB</strong> — Associates in Fidelity and Surety Bonding</p>
                  <p className="leading-relaxed"><strong className="text-white">CRIS</strong> — Construction Risk Insurance Specialist</p>
                </div>
                <a
                  href="mailto:PStolljr@StollAgency.com"
                  className="inline-flex items-center gap-2 mt-5 text-green-500 hover:text-green-400 font-semibold text-sm transition-colors"
                >
                  <i className="ri-mail-line"></i>
                  PStolljr@StollAgency.com
                </a>
              </div>
            </div>

            {/* Andrew Stoll */}
            <div className="bg-slate-800 border border-slate-700 rounded-2xl overflow-hidden shadow-2xl w-full max-w-sm">
              <div className="h-80">
                <img
                  src="https://static.readdy.ai/image/878aa561146e1949d21d2a461d90b0e2/6e028986d6dbcb2d4feaa10fc8e54b3f.webp"
                  alt="Andrew Stoll — Insurance Agent at The Stoll Agency"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-white mb-1">Andrew Stoll</h3>
                <p className="text-green-500 font-semibold mb-4">Insurance Agent</p>
                <div className="space-y-2 text-slate-300 text-sm">
                  <p className="leading-relaxed">Andrew brings a fresh perspective and deep commitment to client service at The Stoll Agency, continuing the family tradition of excellence in construction insurance and surety bonding across <strong className="text-white">Bucks County</strong> and <strong className="text-white">Montgomery County</strong>.</p>
                  <p className="leading-relaxed">Specializing in contractor insurance, general liability, and surety bonds for Pennsylvania businesses.</p>
                </div>
                <a
                  href="mailto:AndrewStoll@StollAgency.com"
                  className="inline-flex items-center gap-2 mt-5 text-green-500 hover:text-green-400 font-semibold text-sm transition-colors"
                >
                  <i className="ri-mail-line"></i>
                  AndrewStoll@StollAgency.com
                </a>
              </div>
            </div>

            {/* Eric Stoll */}
            <div className="bg-slate-800 border border-slate-700 rounded-2xl overflow-hidden shadow-2xl w-full max-w-sm">
              <div className="h-80">
                <img
                  src="https://static.readdy.ai/image/878aa561146e1949d21d2a461d90b0e2/6bea991b72d3b738cff0a8dd4b2697b9.webp"
                  alt="Eric Stoll — Insurance Agent at The Stoll Agency"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-white mb-1">Eric Stoll</h3>
                <p className="text-green-500 font-semibold mb-4">Insurance Agent</p>
                <div className="space-y-2 text-slate-300 text-sm">
                  <p className="leading-relaxed">Eric is dedicated to helping contractors and businesses across <strong className="text-white">Bucks County</strong> and <strong className="text-white">Montgomery County</strong> find the right insurance and surety bonding solutions.</p>
                  <p className="leading-relaxed">Focused on delivering responsive, personalized service that upholds The Stoll Agency's four-generation legacy of excellence in Pennsylvania.</p>
                </div>
                <a
                  href="mailto:EricStoll@StollAgency.com"
                  className="inline-flex items-center gap-2 mt-5 text-green-500 hover:text-green-400 font-semibold text-sm transition-colors"
                >
                  <i className="ri-mail-line"></i>
                  EricStoll@StollAgency.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
